import { useAtom } from "jotai";
import globalState from "../../../store";

const Address: React.FC = () => {
  const [globalStateAtom, setGlobalState] = useAtom(globalState);
  const {
    street_address: streetAddress = "",
    city = "",
    state = "",
    zip_code: zipCode = "",
    country = "US",
  } = globalStateAtom;

  const handleAddressChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setGlobalState({
      ...globalStateAtom,
      [name]: value,
    });
  };

  return (
    <>
      <div className="w-full flex flex-col justify-start gap-y-2">
        <div className="flex flex-col">
          <label htmlFor="street-address" className="flex">
            Street Address
          </label>
          <input
            id="street-address"
            name="street_address"
            className="w-full border-gray-200 border-2 rounded-md p-2"
            type="text"
            onChange={handleAddressChange}
            value={streetAddress}
          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="city" className="flex">
            City
          </label>
          <input
            id="city"
            name="city"
            className="w-full border-gray-200 border-2 rounded-md p-2"
            type="text"
            onChange={handleAddressChange}
            value={city}
          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="state" className="flex">
            State
          </label>
          <input
            id="state"
            name="state"
            className="w-full border-gray-200 border-2 rounded-md p-2"
            type="text"
            onChange={handleAddressChange}
            value={state}
          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="zip-code" className="flex">
            Zip Code
          </label>
          <input
            id="zip-code"
            name="zip_code"
            className="w-full border-gray-200 border-2 rounded-md p-2"
            type="text"
            onChange={handleAddressChange}
            value={zipCode}
          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="country" className="flex">
            Country
          </label>
          <select
            id="country"
            name="country"
            className="w-full border-gray-200 border-2 rounded-md p-2"
            onChange={handleAddressChange}
            value={country}
          >
            <option value="US" defaultChecked>
              United States
            </option>
            <option value="CA">Canada</option>
            <option value="MX">Mexico</option>
          </select>
        </div>
      </div>
    </>
  );
};

export default Address;
